const customFallback = {
  we_apologize: 'Pedimos disculpas, ha ocurrido un error',
  help_our_budly_team: 'Ayuda a nuestro equipo App a solucionar este error',
  report_the_error: 'Informar del error',
}

export default customFallback
